/**
 * งานของฉัน
 * แสดงเฉพาะรายการยังไม่เสร็จ หรือกำลังอยู่ระหว่างดำเนินการเท่านั้น
 */

import React from 'react'
import { JobService, ProjectService, JobGroupService } from '../../../services'
import { Link, withRouter } from 'react-router-dom'
import {
  Button,
  Modal,
  Select,
  Row,
  Col,
  Input,
  message,
  Form,
  Table,
  Popconfirm,
  PageHeader,
  Tag,
  Menu,
  Dropdown,
  DatePicker,
  Card,
  Space,
  Tooltip,
  Pagination,
  Image,
  List,
  Checkbox,
  Avatar,
} from 'antd'
import { Config } from '../../../config'
import './style.scss'
import PaginationDetail from '../../PaginationDetail'

import JobEdit from '../job-edit'
import { Moment, strlimit, openNotificationWithIcon } from '../../../helpers'
import JobView from '../job-view'
import JobAdd from '../job-form'
import iconcustomer from '../../../assets/images/informfix/icon-customer-boy.png'
import iconHome from '../../../assets/images/informfix/icon-home.png'
import _ from 'lodash'
import {
  EditOutlined,
  SearchOutlined,
  QuestionCircleFilled,
  DeleteFilled,
  BankFilled,
  UserOutlined,
  QuestionCircleOutlined,
  TrophyOutlined,
  PlusCircleOutlined,
  DownOutlined,
  EditFilled,
  CalendarFilled,
  CalendarOutlined,
  ExclamationCircleOutlined,
  HomeOutlined,
  ClockCircleOutlined,
  WifiOutlined,
  MenuOutlined,
  HighlightOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { JobTechnichian } from '../JobTechnichian'
import { JobTime } from '../job-time/JobTime'
import TextArea from 'antd/lib/input/TextArea'
import local from 'antd/es/date-picker/locale/th_TH'

const { RangePicker } = DatePicker

const IconText = ({ text, icon }) => (
  <span>
    {' '}
    {icon} {text}
  </span>
)

const { Option } = Select

const formatDateSearch = 'DD/MM/YYYY'

@inject('informStore')
@observer
class JobMyJob extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      data: [],
      list: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showModalView: false,
      showFormCancal: false,
      canJobRemark: '',
      jobId: '',
      searchParams: {
        project_id: '',
        job_status: '',
        q: '',
        f: 'subject',
        year: null,
        sortField: '',
        sortOrder: '',
        myjob: 'yes',
        complete: 'no',
        responsible_id: null,
        range_date: null,
        filter_date_type: 'create_time',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 50,
        pageCount: 0,
      },
      job: {},
      visibleModalView: false,
      visibleModalSig: false,
      confirmLoading: false,
      projects: [{ id: 1, name: 'noom' }],
      listJobStatus: [],
      listJobGroups: [],
      defaultImg:
        'data:image/png;base64,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',
    }

    this.formRef = React.createRef()
    this.formCancelRef = React.createRef()
  }
  UNSAFE_componentWillMount() {
    // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
    this.getProjects()

    // โหลดข้อมูลสถานะ
    this.getJobStatus()
    // โหลดข้อมูลใบแจ้งซ่อม

    this.getJobGroups()
  }
  componentDidMount() {
    const qry = queryString.parse(this.props.location.search)

    if (qry.project_id) {
      this.state.searchParams.project_id = qry.project_id
      this.formRef.current.setFieldsValue({
        project_id: qry.project_id,
      })
    }

    if (qry.f) {
      this.state.searchParams.f = qry.f
      this.formRef.current.setFieldsValue({
        f: qry.f,
      })
    }
    if (qry.complete) {
      this.state.searchParams.complete = qry.complete
      this.formRef.current.setFieldsValue({
        complete: qry.complete,
      })
    }

    if (qry.f == 'date') {
      this.state.searchParams.q = qry.q
      if (qry.q) {
        this.formRef.current.setFieldsValue({
          q: Moment(qry.q).utc(7),
        })
      }
    } else {
      this.state.searchParams.q = qry.q
      this.formRef.current.setFieldsValue({
        q: qry.q,
      })
    }

    this.handleSearch()
  }

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    })
  }

  setQueryString() {
    let params = queryString.stringify(this.state.searchParams)
    this.props.history.push({
      search: params,
    })
  }

  /**
   * โหลดข้อมูลครั้งแรก
   */
  handleSearch = () => {
    this.setState({
      initLoading: true,
      loading: true,
    })

    const values = this.formRef.current.getFieldsValue()
    const pager = this.state.pagination
    const pageParams = { page: 1, 'per-page': pager.pageSize }
    let searchParams = this.state.searchParams

    if (values.job_status !== undefined) {
      searchParams.job_status = values.job_status
    }

    this.setState({
      searchParams,
    })

    const params = { ...pageParams, ...searchParams }


    JobService.myjob(params)
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
        this.setQueryString()
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        })
      })
  }

  /**
   * เปลี่ยนหน้า
   */
  changePage = () => {
    this.setState({
      initLoading: true,
      loading: true,
    })

    const values = this.formRef.current.getFieldsValue()
    const pager = this.state.pagination
    const pageParams = { page: pager.current, 'per-page': pager.pageSize }
    let searchParams = this.state.searchParams

    searchParams.job_status = values.job_status

    if (values.f == 'date' && values.q != 'undefined') {
      let findDate = Moment(values.q)
        .utc(7)
        .format('YYYY-MM-DD')
      if (Moment(values.q).isValid()) {
        searchParams.q = findDate
        values.q = findDate
      } else {
        values.q = null
      }
    }

    if (values.year !== undefined) {
      let findY = Moment(values.year)
        .utc(7)
        .format('YYYY')
      searchParams.year = findY
      values.year = findY
    }

    this.setState({
      searchParams,
    })

    const params = { ...pageParams, ...searchParams }
    JobService.myjob(params)
      .then((rs) => {
        const data = rs.data['items']
        const pager = rs.data['_meta']
        this.setPageParams(pager)

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        })
        this.setQueryString()
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status
          if (code === 404) {
            message.warning(err.response.statusText)
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        })
      })
  }

  /**
   * ข้อมูลสถานะ
   */
  getJobStatus() {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }
  /**
   * ข้อมูลโครงการทั้งหมด
   */
  getProjects() {
    this.setState({
      loadingProject: true,
    })
    ProjectService.all().then((pj) => {
      if (pj) {
        const dataProject = pj.data['data']
        this.setState({
          loadingProject: false,
          projects: dataProject,
        })
      }
    })
  }

  onChangeProject = (value) => {
    let searchParams = this.state.searchParams
    searchParams.project_id = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeWorkStatus = (value) => {
    let searchParams = this.state.searchParams
    searchParams.work_status = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangeSearchFeild = (value) => {
    this.formRef.current.setFieldsValue({
      q: null,
    })
    let searchParams = this.state.searchParams
    searchParams.f = value
    const nowDate = Moment()
      .utc(7)
      .format('YYYY-MM-DD')
    if (value == 'date') {
      searchParams.q = null
      this.formRef.current.setFieldsValue({
        q: null,
      })
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  onChangeQ = (e) => {
    e.persist()
    let searchParams = this.state.searchParams
    if (searchParams.f == 'date') {
    } else {
      searchParams.q = e.target.value
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }
  onChangDate = (value) => {
    let searchParams = this.state.searchParams
    const date = Moment(value)
      .utc(7)
      .format('YYYY-MM-DD')

    if (Moment(value).isValid()) {
      searchParams.q = date
    } else {
      searchParams.q = null
    }
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  setJobStatus = (item, status) => {
    if (status.value != undefined) {
      const jobStatus = status.value
      JobService.setJobStatus(item.id, {
        job_status: jobStatus,
      }).then((rs) => {
        const items = []
        const job = rs.data['data']
        const { data } = this.state
        data.map((record, index) => {
          if (record.id == job.id) {
            data[index] = job
          }
          items.push(data[index])
        })
        this.setState({
          data: items,
        })
        openNotificationWithIcon('success', rs.data.message)
      })
    }
  }

  resetForm() {
    this.setState({
      data: [],
      searchParams: {
        project_id: '',
        job_status: '',
        q: '',
        f: 'subject',
        sortFeild: '',
        sortOrder: '',
        myjob: 'yes',
        responsible_id: null,
        range_date: null,
        filter_date_type: 'create_time',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    })
    this.formRef.current.resetFields()
    this.setQueryString()

    this.handleSearch()
  }

  /**
   * ปุ่มตกลงยกเลิกงาน
   * @param {*} values
   */
  submitCancel = (values) => {
    this.formCancelRef.current.submit()
  }

  /**
   *
   * @param {*} values
   */
  handleSubmitCancel = (values) => {
    const { confirm } = Modal
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: 'ยืนยันยกเลิก ?',
      onOk() {

        if (values) {
          const params = {
            id: values.id,
            cancel_remark: values.cancel_remark,
          }
          JobService.cancel(values.id, params).then((rs) => {
            if (rs) {
              const returnData = rs.data['data']
              const { list, data } = this.state
              // let data = [...this.state.data]
              data.map((row, rowKey) => {
                if (row.id == values.id) {
                  data[rowKey] = returnData
                  this.setState({
                    data,
                  })
                }
              })
              message.success(rs.data['message'])
              this.hideModalCancel()
            }
          })
        }
      },
      onCancel() {
      
      },
    })
  }
  setVisibleModalAdd = (value) => {
    this.setState({
      showFormAdd: value,
    })
  }
  setVisibleModalEdit = (value) => {
    this.setState({
      showFormEdit: value,
    })
  }
  showModalEdit = (item) => {
    this.setState({
      jobId: item.id,
      job: {},
    })
    JobService.view(item.id).then((rs) => {
      this.setState({
        job: rs.data.data,
        showFormEdit: true,
      })

      this.props.informStore.setJob(this.state.job)
    })
  }
  showModalView = (item) => {
    this.setState({
      jobId: item.id,
      showModalView: true,
      job: {},
    })
    JobService.view(item.id).then((rs) => {
      this.setState({
        job: rs.data['data'],
      })
      this.props.informStore.setJob(this.state.job)
    })
  }

  hideModalEdit = () => {
    const job = this.props.informStore.getJob
    this.setState({
      showFormEdit: false,
      jobId: '',
      job: {},
    })
    this.props.informStore.setEditId('')
    if (job) {
      const { data } = this.state
      const items = []
      if (data) {
        data.map((item, index) => {
          if (item.id == job.id) {
            data[index] = job
          }
          items.push(data[index])
        })
        this.setState({
          data: items,
        })
      }
    }
  }

  hideModalView = () => {
    this.props.informStore.setJob({})
    this.setState({
      showModalView: false,
      jobId: '',
      job: {},
    })
  }

  showModalCancel = (record) => {
    this.setState(
      {
        showFormCancal: true,
        jobId: record.id,
        job: record,
      },
      () => {
        if (this.state.showFormCancal == true) {
          this.formCancelRef.current.setFieldsValue({
            id: record.id,
            list: record.list,
            description: record.description,
            cancel_remark: '',
          })
        }
      },
    )
  }

  hideModalCancel = () => {
    this.props.informStore.setJob({})
    this.setState({
      showFormCancal: false,
      jobId: '',
      job: {},
      jobCancelReamrk: '',
    })
    this.formCancelRef.current.setFieldsValue({
      id: '',
      cancel_remark: '',
    })
  }

  /**
   * ลบงาน
   */
  deleteJob = (record) => {
    const items = this.state.data
    JobService.delete(record.id).then((rs) => {
      message.success(rs.data['message'])
      let newItem = items.filter((item, key) => {
        return item.id != record.id
      })
      this.setState({
        data: newItem,
      })
    })
  }

  /**
   * ปิดคิวงานให้เสร็จ
   */
  closeJob = (item) => {
    let data = [...this.state.data]
    const index = data.indexOf(item)
    JobService.close(item.id).then((rs) => {
      data[index] = rs.data.data['job']
      this.setState({
        data,
      })
    })
  }

  /**
   * เคลียร์งานเก่าที่ค้าง
   */
  clearJobAuto = () => {
    JobService.clearJobAuto().then((rs) => {

    })
  }

  /**
   * ปุ่มกดเริ่มทำงาน
   */
  confirmStartWork = (job) => {
    JobService.start(job.id)
      .then((rs) => {
        if (rs) {
          this.props.informStore.setJob(rs.data.data)
          message.success(rs.data.message)
          this.handleSearch()
        }
      })
      .catch((err) => {

        message.error(err.response.message)
      })
  }

  /**
   * ปุ่มกดส่งงานเมื่อทำเสร็จ
   */
  confirmSendJob = (job) => {
    JobService.sendJob(job.id)
      .then((rs) => {

        if (rs) {
          this.props.informStore.setJob(rs.data.data)
          message.success(rs.data.message)
          this.handleSearch()
        }
      })
      .catch((err) => {

        message.error(err.response.message)
      })
  }

  /**
   *  เลือกงานที่ไม่มีวันนัดหมาย
   * @param {*} e
   */
  onChangeCheckboxJob = (e) => {
    const check = e.target.checked
    let searchParams = this.state.searchParams
    searchParams.jobnotime = check ? 'yes' : 'no'
    this.setState({
      searchParams,
    })
    this.formRef.current.setFieldsValue({
      jobnotime: searchParams.jobnotime,
    })
    this.setQueryString()
    this.handleSearch()
  }

  /*
   * เลือกช่วงเวลา
   */
  onChangRangeDate = (e) => {
    const { searchParams } = this.state
    searchParams.range_date = ''

    if (e) {
      const d1 = e[0].format('YYYY-MM-DD')
      const d2 = e[1].format('YYYY-MM-DD')

      searchParams.range_date = `${d1},${d2}`
      this.setState({
        searchParams,
      })
      this.handleSearch()
    }
  }

  /**
   * ข้อมูลหมวดหมู่งาน
   */
  getJobGroups() {
    JobGroupService.all().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobGroups: data })
      }
    })
  }

  onChangeJobGroup = (value) => {
    let searchParams = this.state.searchParams
    searchParams.group_id = value
    this.setState({
      searchParams,
    })
    this.setQueryString()
  }

  render() {
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      projects,
      listJobStatus,
      listJobGroups,
      searchParams,
      list,
      data,
    } = this.state

    const job = this.props.job

    /**
     * แสดงรายละเอียดโครงการและบ้าน
     */
    const showHomeDetail = (record) => {
      return (
        <div
          style={{
            fontSize: '12px',
          }}
        >
          {record.project ? (
            <div>
              <IconText
                key={'icon-project' + record.id}
                icon={<BankFilled />}
                text={record.project.name}
              />
            </div>
          ) : null}
          {record.home ? (
            <div>
              <IconText
                key={'icon-home' + record.id}
                icon={<HomeOutlined />}
                text={
                  'บ้านเลขที่ ' +
                  (record.home.home_no != undefined ? record.home.home_no : '-')
                }
              />
              {'  '}
              <IconText
                key={'icon-planno' + record.id}
                icon={<HomeOutlined />}
                text={
                  ' แปลง ' +
                  (record.home.plan_no != undefined ? record.home.plan_no : '-')
                }
              />
            </div>
          ) : null}
        </div>
      )
    }

    const menuAction = (record) => (
      <Menu>
        <Menu.Item onClick={() => this.showModalView(record)}>
          <SearchOutlined /> ดูรายละเอียด
        </Menu.Item>
        {/* แสดงปุ่มปิดงานถ้าใบแจ้งซ่อมอยู่ในสถานะ [กำลังดำเนินการ] และมีคิวงานมากกว่า 0 รายการ*/}
        {canCloseJob(record) ? (
          <Tooltip title="ปิดงาน (เปลี่ยนสถานะเป็นเสร็จสิ้น)" placement="left">
            <Popconfirm
              title={
                'ยืนยันงานเสร็จสิ้น หมายเลข ' + record.id + ' ใช่หรือไม่ ？'
              }
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              okText="งานเสร็จแล้ว"
              cancelText="ยกเลิก"
              placement="left"
              onConfirm={() => this.closeJob(record)}
            >
              <Menu.Item key="m_close" icon={<TrophyOutlined />}>
                ปิดงาน
              </Menu.Item>
            </Popconfirm>
          </Tooltip>
        ) : null}
      </Menu>
    )

    /**
     * ตรวจสอบว่าสามารถปิดงานได้อยู่หรือไม่
     * @param {*} record
     */
    const canCloseJob = (record) => {
      const c1 = record.job_status.toString() == Config.job.status.PROCEED.value
      return c1
    }

    const buttonAction = (item) => {
      return (
        <>
          {/* แสดงปุ่มเริ่มทำงาน */}
          {item.job_status == Config.job.status.OPEN.value &&
          item.start_job_at < 1 &&
          item.send_job_at < 1 ? (
            <>
              <Popconfirm
                placement="topRight"
                title={'ยืนยันเริ่มทำงาน #' + item.id + ' ?'}
                onConfirm={() => this.confirmStartWork(item)}
                okText="ใช่"
                cancelText="ไม่ใช่"
              >
                <Button
                  type="default"
                  size="small"
                  style={{
                    backgroundColor: 'blue',
                    color: '#ffffff',
                  }}
                >
                  กด!เริ่มดำเนินการ
                </Button>
              </Popconfirm>
            </>
          ) : null}
        </>
      )
    }

    const listItemBgColor = (item) => {
      switch (item.job_status) {
        case -1:
          return '#ffc1df' // canceled
        case 1:
          return '#ffddb7' // open
        case 4:
          return '#e6ffce' // in progress

        default:
          break
      }
    }

    return (
      <React.Fragment>
        <Card title="Filter">
          <div style={{ marginTop: 15 }}>
            {/* {listJobStatus
              ? listJobStatus.map((status, key) => (
                  <Button
                    shape="round"
                    type="info"
                    key={key}
                    disabled={
                      status.value == this.state.searchParams.job_status
                    }
                    onClick={() => {
                      this.formRef.current.setFieldsValue({
                        job_status: status.value,
                      })
                      this.state.searchParams.job_status = status.value
                      this.forceUpdate()
                      this.setQueryString()
                      this.handleSearch()
                    }}
                  >
                    {status.text}
                  </Button>
                ))
              : null}
            <Button
              shape="round"
              type="info"
              htmlType="reset"
              className="submit"
              onClick={() => this.showAllStatus()}
              title="ทุกสถานะ"
              disabled={'' == this.state.searchParams.job_status}
            >
              ทุกสถานะ
            </Button> */}
            <Button
              shape="round"
              type="info"
              onClick={() => {

                this.formRef.current.setFieldsValue({
                  complete: 'no',
                })
                searchParams.complete = 'no'
                this.setState({
                  searchParams,
                })
                this.setQueryString()
                this.handleSearch()
              }}
              disabled={'no' == this.state.searchParams.complete}
            >
              ยังไม่แล้วเสร็จ
            </Button>
            <Button
              shape="round"
              type="info"
              onClick={() => {
                this.formRef.current.setFieldsValue({
                  complete: 'yes',
                })
                searchParams.complete = 'yes'
                this.setState({
                  searchParams,
                })
                this.setQueryString()
                this.handleSearch()
              }}
              disabled={'yes' == this.state.searchParams.complete}
            >
              เสร็จเรียบร้อย
            </Button>
          </div>
          <Form
            ref={this.formRef}
            onFinish={this.handleSubmitSearch}
            initialValues={{
              job_status: null,
            }}
          >
            <Row justify="start" gutter={{ xs: 3, sm: 3, md: 3 }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="project_id">
                  <Select
                    loading={loadingProject}
                    key="dropdown-project"
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="-เลือกโครงการ-"
                    optionFilterProp="label"
                    optionLabelProp="label"
                    onChange={this.onChangeProject}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    size="small"
                  >
                    {projects.map((p, index) => (
                      <Option
                        key={'project-' + p.id}
                        value={p.id}
                        label={p.name}
                      >
                        {p.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="group_id">
                  <Select
                    key="dropdown-job-group"
                    showSearch
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="-หมวดหมู่งาน-"
                    optionFilterProp="label"
                    optionLabelProp="label"
                    onChange={this.onChangeJobGroup}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    size="small"
                  >
                    {listJobGroups.map((p, index) => (
                      <Option key={'gorup-' + p.id} value={p.id} label={p.name}>
                        {p.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="f">
                  <Select
                    placeholder="-ประเภทคำค้นหา-"
                    style={{ width: '100%' }}
                    onChange={this.onChangeSearchFeild}
                    size="small"
                    defaultValue={this.state.searchParams.f}
                  >
                    <Option value="informfix_id" label="เลขที่ใบแจ้งซ่อม">
                      เลขที่ใบแจ้งซ่อม
                    </Option>
                    <Option value="subject" label="หัวข้อ">
                      หัวข้อ
                    </Option>
                    <Option value="description" label="รายละเอียด">
                      รายละเอียด
                    </Option>
                    <Option value="home_no" label="บ้านเลขที่">
                      บ้านเลขที่
                    </Option>
                    <Option value="plan_no" label="แปลงบ้าน">
                      แปลงบ้าน
                    </Option>
                    <Option value="id" label="ID">
                      ID
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="q">
                  {searchParams.f == 'date' ? (
                    <DatePicker
                      format={formatDateSearch}
                      size="small"
                      locale={local}
                    />
                  ) : (
                    <Input
                      name="q"
                      placeholder="คำค้นหา.."
                      onChange={this.onChangeQ}
                      onPressEnter={this.handleSearch}
                      size="small"
                      allowClear
                    />
                  )}
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="filter_date_type">
                  <Select
                    defaultValue={this.state.searchParams.filter_date_type}
                    key="dropdown-filter-date-type"
                    style={{ width: '100%' }}
                    optionFilterProp="label"
                    optionLabelProp="label"
                    onChange={(value) => {
                      const { searchParams } = this.state
                      searchParams.filter_date_type = value
                      this.setQueryString()
                      if (searchParams.range_date) {
                        this.handleSearch()
                      }
                    }}
                    size="small"
                  >
                    <Select.Option value="appointment" label="เวลานัดหมาย">
                      เวลานัดหมาย
                    </Select.Option>
                    <Select.Option value="create_time" label="เวลาบันทึกข้อมูล">
                      เวลาบันทึกข้อมูล
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="range_date">
                  <RangePicker
                    format={formatDateSearch}
                    size="small"
                    onChange={this.onChangRangeDate}
                    locale={local}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Checkbox onChange={this.onChangeCheckboxJob} />{' '}
                งานที่ยังไม่ได้ระบุเวลานัด
              </Col>
            </Row>
            <Row justify="start">
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 4 }}
              >
                <Button
                  type="primary"
                  loading={loading || initLoading}
                  disabled={loading || initLoading}
                  icon={<SearchOutlined />}
                  onClick={this.handleSearch}
                  title="ค้นหา"
                  size="small"
                >
                  ค้นหา
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>

        {/* ////////////// START Modal view /////////// */}
        <Modal
          open={this.state.showModalView}
          onCancel={this.hideModalView}
          afterClose={() => {
            this.hideModalView()
          }}
          footer=""
          centered
          bodyStyle={{ padding: '5' }}
          closable
          width={720}
        >
          {this.state.jobId && this.state.showModalView ? (
            <JobView
              jobId={this.state.jobId}
              job={this.props.informStore.getJob}
              hideModal={this.hideModalView}
              projects={this.state.projects}
              canDelete={
                this.props.informStore.getJob.job_status !=
                  Config.job.status.COMPLETE.value &&
                this.props.informStore.getJob.job_status !=
                  Config.job.status.CANCELED.value
              }
              showStartWork={true}
            />
          ) : null}
        </Modal>
        {/* ////////////// END Modal view /////////// */}

        {data ? (
          <>
            <List
              className="job__list"
              loading={this.state.loading}
              itemLayout="horizontal"
              dataSource={data}
              size="small"
              pagination={{
                defaultCurrent: 1,
                total: pagination.total,
                pageSize: pagination.pageSize,
                current: pagination.current,
                onChange: (page, pageSize) => {
                  let pagination = this.state.pagination
                  pagination.current = page
                  pagination.pageSize = pageSize
                  this.setState({
                    pagination,
                  })
                  this.changePage()
                },
                onShowSizeChange: (page, pageSize) => {
                  let pagination = this.state.pagination
                  pagination.current = page
                  pagination.pageSize = pageSize
                  this.setState({
                    pagination,
                  })
                  this.changePage()
                },
              }}
              footer={<PaginationDetail data={pagination} />}
              renderItem={(item) => (
                <List.Item
                  className="list-item"
                  style={{
                    backgroundColor: listItemBgColor(item),
                  }}
                  actions={[
                    <>
                      {item.imageCover ? (
                        <Image
                          key={'img' + item.id}
                          height={50}
                          width={50}
                          src={item.imageCover.thumbnail}
                          fallback={iconHome}
                          preview={false}
                          onClick={() => this.showModalView(item)}
                        />
                      ) : null}
                    </>,
                    <Dropdown
                      key={'dd' + item.id}
                      className="menu_action"
                      overlay={menuAction(item)}
                    >
                      <Button
                        type="default"
                        size="small"
                        key={'menu_option' + item.id}
                      >
                        <strong>J{item.id}</strong> <DownOutlined />
                      </Button>
                    </Dropdown>,
                  ]}
                >
                  <List.Item.Meta
                    avatar={<Avatar src={iconHome} />}
                    title={
                      <>
                        <a onClick={() => this.showModalView(item)}>
                          <span
                            className="unit_no"
                            style={{
                              fontSize: 14,
                              color: 'blue',
                            }}
                          >
                            {item.home ? item.home.home_no : ''}{' '}
                          </span>

                          <span
                            className="project"
                            style={{
                              color: '#222222',
                              fontSize: 12,
                              display: 'inline-block',
                            }}
                          >
                            ({item.project ? item.project.name : ''})
                          </span>
                          <div
                            className="time"
                            style={{
                              fontSize: 12,
                              color: '#828282',
                              fontStyle: 'italic',
                              display: 'block',
                            }}
                          >
                            <JobTime data={item} />
                          </div>
                        </a>
                      </>
                    }
                    description={
                      <div
                        style={{
                          color: '#222222',
                          fontSize: 14,
                        }}
                      >
                        {item.group ? (
                          <Tooltip title="หมวดงาน">
                            <Tag>{item.group.name}</Tag>
                          </Tooltip>
                        ) : (
                          ''
                        )}
                        <Tooltip title="สถานะงาน">
                          <span className="job_status" style={{ fontSize: 12 }}>
                            ({item.jobStatusName})
                          </span>
                        </Tooltip>

                        {/* มีลายเซ็นต์ลูกค้า */}
                        {item.signatureCustomerData ? (
                          <span style={{ fontSize: 12, marginLeft: 10 }}>
                            <Tooltip
                              title="มีลายเซ็นต์ลูกค้า"
                              className="job_singnature"
                            >
                              <HighlightOutlined />
                            </Tooltip>
                          </span>
                        ) : (
                          ''
                        )}
                        {/* ยืนยืนลูกค้าแล้ว */}
                        {item.close_job == 1 ? (
                          <span style={{ fontSize: 12, marginLeft: 10 }}>
                            <Tooltip
                              title="ยืนยันกับลูกค้าแล้ว"
                              className="job_confirm"
                            >
                              <CheckSquareOutlined />
                            </Tooltip>
                          </span>
                        ) : (
                          ''
                        )}

                        <p>
                          <strong>{item.list}</strong> {item.description}
                        </p>

                        {/* หมายเหตุการยกเลิก */}
                        {item.cancel_remark ? (
                          <div
                            style={{ fontSize: 12, marginLeft: 10 }}
                            className="job_cancel_remark"
                          >
                            <Tooltip title="หมายเหตุยกเลิก">
                              <u>หมายเหตุยกเลิก: </u>
                              <span style={{ color: 'red' }}>
                                {' '}
                                {item.cancel_remark}
                              </span>
                            </Tooltip>
                          </div>
                        ) : (
                          ''
                        )}

                        <Row gutter={8}>
                          <Col className="">
                            <Tooltip title="ช่างผู้รับผิดชอบงาน">
                              <div style={{ fontSize: 12, color: '#333333' }}>
                                <Image
                                  src={iconcustomer}
                                  width={30}
                                  preview={false}
                                />
                                {item.responsible_name}
                              </div>
                            </Tooltip>
                          </Col>
                          <Col className="">{buttonAction(item)}</Col>
                        </Row>
                      </div>
                    }
                  />
                  <div></div>
                </List.Item>
              )}
            />
          </>
        ) : (
          ''
        )}
      </React.Fragment>
    )
  }
}
export default withRouter(JobMyJob)
